import React, { FC } from 'react';
import styled from 'styled-components';
import { Icon } from '../icon';
import { Checkbox } from '../checkbox';
import Crown from '../svg/crown';

//#region BulkSelectionButton
const BulkSelectionButtons = styled.div`
    display: flex;
    margin-right: auto;
`;

const BulkSelectionButtonsList = styled.ul`
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    align-items: center;
`;

const BulkSelectionButton = styled.li<{ disabled?: boolean }>`
    margin-right: 25px;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;

    &:hover {
        opacity: 0.7;
    }

    ${(props) =>
        props.disabled &&
        `
        opacity: 0.5;
    `}
`;

const BulkSectionButtonIcon = styled(Icon)<{ $isActive?: boolean }>`
    width: 18px;
    height: 18px;
    stroke-width: 0px;
    color: ${(props) => props.theme.input.color};
    margin-right: 5px;

    ${(props) =>
        props.$isActive &&
        `
        color: ${props.theme.app.secondary};
    `}
`;

const CrownUpgrade = styled(Icon)`
    margin-left: 5px;
    color: #f0047f;
    width: 15px;
`;

export interface BulkButton {
    key: string;
    tooltip?: string;
    label: string;
    icon?: React.ReactElement<React.SVGAttributes<SVGElement>>;
    isActive?: boolean;
    hidden?: boolean;
    isCheckbox?: boolean;
    checked?: boolean;
    disabled?: boolean;
    requireUpgrade?: boolean;
    onClick: (button: BulkButton) => void;
}

export const BulkSelectionSection: FC<React.ComponentProps<'button'> & { buttons: BulkButton[] }> = (props) => {
    return (
        <BulkSelectionButtons>
            <BulkSelectionButtonsList>
                {props.buttons.map((button) => (
                    <BulkSelectionButton
                        key={button.key}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (!button.disabled) button.onClick(button);
                        }}
                        disabled={button.disabled}
                    >
                        {/* Normal version */}
                        {!button.isCheckbox && (
                            <>
                                {button.icon && (
                                    <BulkSectionButtonIcon tooltip={button.tooltip} $isActive={button.isActive}>
                                        {button.icon}
                                    </BulkSectionButtonIcon>
                                )}
                                <span>{button.label}</span>
                            </>
                        )}

                        {/* Checkbox version */}
                        {button.isCheckbox && <Checkbox checked={button.checked ?? false} onChange={() => null} label={<span>{button.label}</span>} />}

                        {/* Bulk operation requires upgrade */}
                        {button.requireUpgrade && (
                            <CrownUpgrade>
                                <Crown />
                            </CrownUpgrade>
                        )}
                    </BulkSelectionButton>
                ))}
            </BulkSelectionButtonsList>
        </BulkSelectionButtons>
    );
};

//#endregion
